import { useCallback } from "react";

import { PATHS } from "b2b/constants";
import { useRedirect } from "b2b/hooks";
import { useServerMessage } from "b2b/i18n";
import { useRedirectToProvozniInformaceDetail } from "b2b/redirects";

import { FILES } from "b2b/api";
import useDelete from "./useDelete";

export default function useCard({ data, onDeleteSuccess }) {
  const redirect = useRedirect();
  const redirectToDetail = useRedirectToProvozniInformaceDetail();

  const handleRedirectToDetail = useCallback(() => {
    redirectToDetail(data.id);
  }, [data.id]);

  const redirectToEdit = useCallback(() => {
    redirect(PATHS.PROVOZNI_INFORMACE.EDITACE, {
      id: data.id
    });
  }, [data.id]);

  const onEdit = useCallback(
    e => {
      e.stopPropagation();
      redirectToEdit();
    },
    [redirectToEdit]
  );

  const deleteProvozniInformace = useDelete({
    id: data?.id,
    onSuccess: onDeleteSuccess
  });
  const onDelete = useCallback(
    e => {
      e.stopPropagation();
      deleteProvozniInformace();
    },
    [deleteProvozniInformace]
  );

  const imageSrc = data?.obrazek?.key
    ? FILES.provozniInformace(data?.obrazek?.key)
    : undefined;
  const serverMessage = useServerMessage();

  return {
    imageSrc,
    nazev: serverMessage(data, "nazev"),
    popis: serverMessage(data, "popis"),
    onDetail: handleRedirectToDetail,
    onEdit,
    onDelete
  };
}
